export enum WellKnownAddressTypes {
  postal = 1,
  street = 2,
}
